import { store } from 'app/redux/store';
import { IUser } from 'app/services/user';
import { updateKey } from '../edit/TaxQuestionnaire/PersonalDetails/TheBasics/Family/slice';

export default function autoFillFamilySlice(user: IUser) {
  const { spouse } = user;

  store.dispatch(
    updateKey({ key: 'spouseFirstName', value: spouse?.firstname }),
  );
  store.dispatch(updateKey({ key: 'spouseLastName', value: spouse?.lastname }));
  store.dispatch(
    updateKey({ key: 'spouseDateOfBirth', value: spouse?.birth_date }),
  );
  store.dispatch(
    updateKey({ key: 'spouseOccupation', value: spouse?.occupation }),
  );
  if (spouse?.ssn) {
    store.dispatch(
      updateKey({ key: 'spouseHasSocialSecurityNum', value: 'yes' }),
    );
    store.dispatch(
      updateKey({ key: 'spouseSocialSecurityNum', value: spouse?.ssn }),
    );
  }
}
